import { TabsKeys, TabsLabels } from 'enums/AccountsListEnums';
import React from 'react';
import styles from './AccountsList.module.scss';
import UserDetails from 'shared/components/Accounts/UserDetails/index';
import clsx from 'clsx';
import Pricing from 'shared/components/Accounts/Pricing';
import ApiKeys from 'views/ApiKeys';
import { ReactComponent as UserIcon } from 'assets/icons/user_profile.svg';
import { ReactComponent as PricingIcon } from 'assets/icons/pricing.svg';
import { ReactComponent as KeyTabIcon } from 'assets/icons/key.svg';
interface getTabsProps {
  isActiveTab: (tab: string) => boolean;
  handleTabChange: (tab: string) => void;
}

export const getTabs = ({ isActiveTab, handleTabChange }: getTabsProps) => {
  return [
    {
      children: <UserDetails />,
      active: isActiveTab(TabsKeys.USER_DETAILS),
      label: (
        <span
          className={clsx({
            [styles.spanContainer]: true,
            [styles.spanActive]: isActiveTab(TabsKeys.USER_DETAILS),
          })}
          onClick={() => handleTabChange(TabsKeys.USER_DETAILS)}>
          <UserIcon
            className={clsx({
              [styles.userIcon]: true,
              [styles.iconDef]: true,
              [styles.icon]: isActiveTab(TabsKeys.USER_DETAILS),
            })}
          />
          {TabsLabels.USER_DETAILS}
        </span>
      ),
      key: TabsKeys.USER_DETAILS,
    },
    {
      children: <Pricing />,
      active: isActiveTab(TabsKeys.PRICING),
      label: (
        <span
          className={clsx({
            [styles.spanContainer]: true,
            [styles.spanActive]: isActiveTab(TabsKeys.PRICING),
          })}
          onClick={() => handleTabChange(TabsKeys.PRICING)}>
          <PricingIcon
            className={clsx({
              [styles.icon]: isActiveTab(TabsKeys.PRICING),
            })}
          />
          {TabsLabels.PRICING}
        </span>
      ),
      key: TabsKeys.PRICING,
    },
    {
      children: <ApiKeys embedded />,
      active: isActiveTab(TabsKeys.API_KEYS),
      label: (
        <span
          className={clsx({
            [styles.spanContainer]: true,
            [styles.spanActive]: isActiveTab(TabsKeys.API_KEYS),
          })}
          onClick={() => handleTabChange(TabsKeys.API_KEYS)}>
          <KeyTabIcon
            className={clsx({
              [styles.keyTabIcon]: true,
              [styles.icon]: isActiveTab(TabsKeys.API_KEYS),
            })}
          />
          {TabsLabels.API_KEYS}
        </span>
      ),
      key: TabsKeys.API_KEYS,
    },
  ];
};
